<template>
  <v-dialog v-model="dialog" max-width="90%" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6">Pregled PDF dokumenta</span>
        <div>
          <v-btn
            icon
            @click="downloadPdf"
            :loading="downloading"
            class="mr-2"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="pa-0">
        <div v-if="loading" class="text-center pa-8">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          <div class="mt-4">Učitavam PDF...</div>
        </div>

        <div v-else-if="error" class="text-center pa-8">
          <v-icon color="error" size="64">mdi-alert-circle</v-icon>
          <div class="mt-4 text-error">{{ error }}</div>
          <v-btn color="primary" @click="loadPdf" class="mt-4">
            Pokušaj ponovno
          </v-btn>
        </div>

        <div v-else-if="pdfUrl" class="pdf-container">
          <iframe
            :src="pdfUrl"
            width="100%"
            height="600px"
            style="border: none;"
          ></iframe>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Zatvori</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { eracunApi } from '@/api/eracun'
import state from '@/state'

export default {
  name: 'PdfViewerDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: [String, Number],
      default: null
    },
    documentName: {
      type: String,
      default: 'document'
    }
  },
  data () {
    return {
      loading: false,
      downloading: false,
      error: null,
      pdfUrl: null,
      pdfBlob: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal && this.documentId) {
        this.loadPdf()
      } else if (!newVal) {
        this.cleanup()
      }
    }
  },
  methods: {
    async loadPdf () {
      this.loading = true
      this.error = null
      this.cleanup()

      try {
        const companyId = state.getCurrentCompany().id
        const response = await eracunApi.getDocumentPdf(this.documentId, companyId)

        // Response sadrži { pdf: "base64string" }
        if (response.pdf) {
          // Dekodiranje base64 u binary
          const binaryString = atob(response.pdf)
          const bytes = new Uint8Array(binaryString.length)

          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i)
          }

          this.pdfBlob = new Blob([bytes], { type: 'application/pdf' })
          this.pdfUrl = window.URL.createObjectURL(this.pdfBlob)
        } else {
          throw new Error('PDF podatak nije pronađen u odgovoru')
        }
      } catch (error) {
        console.error('Error loading PDF:', error)
        this.error = 'Greška pri učitavanju PDF dokumenta'
      } finally {
        this.loading = false
      }
    },

    async downloadPdf () {
      if (!this.pdfBlob) {
        return
      }

      this.downloading = true
      try {
        const link = document.createElement('a')
        link.href = this.pdfUrl
        link.download = `${this.documentName}.pdf`
        link.click()
      } catch (error) {
        console.error('Error downloading PDF:', error)
        this.$emit('error', 'Greška pri preuzimanju PDF-a')
      } finally {
        this.downloading = false
      }
    },

    cleanup () {
      if (this.pdfUrl) {
        window.URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
      this.pdfBlob = null
      this.error = null
    }
  },

  beforeDestroy () {
    this.cleanup()
  }
}
</script>

<style scoped>
.pdf-container {
  max-height: 600px;
  overflow: hidden;
}

.v-dialog {
  overflow-y: auto;
}
</style>
